// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-notification-wrapper{overflow:visible!important;overflow:initial!important}.fade-right-enter-active,.fade-right-leave-active,.fade-right-move{transition:all .5s}.fade-right-enter,.fade-right-leave-to{opacity:0;transform:translateX(-100%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
